import * as TYPES from './type-actions.js';
import {CompassHeading, deepClone, delay, isIos, throttle, wait} from "../../utils";
import {
	MAP_FIT_VIEW_MODE_A,
	MAP_FIT_VIEW_MODE_B, MAP_FIT_VIEW_MODE_C, MAP_FIT_VIEW_MODE_D, MAP_FIT_VIEW_MODE_E,
	MAP_MARGIN_BOTTOM_BUFFER,
	MAP_MODE_NORMAL,
	MAP_MODE_RUNNING
} from "./store";
import {MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL} from "./type-actions";

export const MAP_SET_VIEWPORT_DELAY = 30;

export function MapService(context) {
	function _getMapInstance() {
		return context.$store.state.map.map.instance;
	}
	function _getUserPos() {
		return context.$store.state.map.dataSource.userPos;
	}
	// function _getDataSource() {
	// 	return context.$store.getters.dataSource;
	// }
	function _getMapMargins() {
		return deepClone(context.$store.state.map.map.margins);
	}
	function _getMapMarginBottom() {
		let margins = _getMapMargins();
		return margins ? margins[2] : 0;
	}
	function _getMapMode() {
		return context.$store.state.map.map.mode;
	}
	function _getMapFitViewMode() {
		return context.$store.state.map.map.fitViewMode;
	}
	function _getStateOnStopDraggable() {
		return context.$store.state.map.state.onStopDraggable;
	}
	function _getStateOffStopDraggable() {
		return context.$store.state.map.state.offStopDraggable;
	}
	function _getStops() {
		return context.$store.state.map.dataSource.stops;
	}
	function _getAreas() {
		return context.$store.state.map.dataSource.areas;
	}
	function _getOnStop() {
		return context.$store.state.map.dataSource.onStop;
	}
	function _getOffStop() {
		return context.$store.state.map.dataSource.offStop;
	}
	function _getRunningOnStop() {
		return context.$store.state.map.dataSource.runningOnStop;
	}
	function _getRunningOffStop() {
		return context.$store.state.map.dataSource.runningOffStop;
	}
	function _getBusPos() {
		return context.$store.state.map.dataSource.busPos;
	}
	function _getDragNearestOffStop() {
		return context.$store.state.map.state.dragNearestOffStop;
	}
	function _getOverlayAreaPolygons() {
		return context.$store.state.map.overlays.areaPolygons;
	}
	function _getOverlayStopMarkers() {
		return context.$store.state.map.overlays.stopMarkers;
	}
	function _getOverlayOnStopMarker() {
		return context.$store.state.map.overlays.onStopMarker;
	}
	function _getOverlayOffStopMarker() {
		return context.$store.state.map.overlays.offStopMarker;
	}
	function _getOverlayOnStopLabel() {
		return context.$store.state.map.overlays.onStopLabel;
	}
	function _getOverlayOffStopLabel() {
		return context.$store.state.map.overlays.offStopLabel;
	}
	function _getOverlayBusMarker() {
		return context.$store.state.map.overlays.busMarker;
	}
	function _getOverlayUserPosMarker() {
		return context.$store.state.map.overlays.userMarker;
	}
	function _getOverlayRunningOnStopMarker() {
		return context.$store.state.map.overlays.runningOnStopMarker;
	}
	function _getOverlayRunningOffStopMarker() {
		return context.$store.state.map.overlays.runningOffStopMarker;
	}
	function _getOverlayRunningOnStopLabel() {
		return context.$store.state.map.overlays.runningOnStopLabel;
	}
	function _getOverlayRunningOffStopLabel() {
		return context.$store.state.map.overlays.runningOffStopLabel;
	}
	function _getOverlayPosingLabel() {
		return context.$store.state.map.overlays.posingLabel;
	}
	// function _getDataAreasPath() {
	// 	return context.$store.state.map.dataSource.areas;
	// }
	const dispatch = context.$store.dispatch;
	function setMapMode(mode) {
		dispatch(TYPES.MAP__SET_MAP_MODE, mode);
	}
	function setMapFitViewMode(mode) {
		dispatch(TYPES.MAP__SET_FIT_VIEW_MODE, mode);
	}
	function setStatePoiSearching(payload)  {
		dispatch(TYPES.MAP__SET_STATE_POI_SEARCHING, payload);
	}
	function setFitView(points) {
		let map = _getMapInstance();
		if (!map) {
			return;
		}
		let margins = _getMapMargins();
		console.log('margins', margins);
		if (!points) {
			// 根据区域、上、下车站缩放地图
			if (context.$MapService.isMapFitViewModeA()) {
				let areas = _getAreas();
				let onStop = _getOnStop();
				let offStop = _getOffStop();
				let userPos = _getUserPos();
				let [area = []] = areas || [];
				console.log('我是运营的站点', context.$store.state.map.dataSource.stops)
				// 所有运营站列表
				var allStopsPoints = [...(context.$store.state.map.dataSource.stops || [])].filter(p => p).map((item) => new BMapGL.Point(item.lng, item.lat))
				let areaPoints = Array.from(area || []).filter(p => !!p).map(([lng, lat]) => new BMapGL.Point(lng, lat)) || [];
				let {point: onStopPoint} = onStop || {};
				let {point: offStopPoint} = offStop || {};
				if (onStopPoint && offStopPoint) {
					points = [onStopPoint, offStopPoint];
					margins[0] += 80;
					margins[1] += 40;
					margins[3] += 40;
				} else if (onStopPoint && !offStopPoint) {
					let map = _getMapInstance();
					if (map) {
						let [lng, lat] = userPos || {};
						if (!lng || !lat) {
							map.centerAndZoom(onStopPoint, 14);
							return;
						} else {
							let farAway = isPointFarFromUser(onStopPoint, 10000);
							if (farAway) {
								map.centerAndZoom(onStopPoint, 14);
								return;
							}
							let userPoint = new BMapGL.Point(lng, lat);
							points = [onStopPoint, userPoint];
							margins[0] += 80;
							margins[1] += 40;
							margins[3] += 40;
						}
					}
				} else {
					const cityId = context.$store.state.app.cityId || context.$route.query.cityId || localStorage.getItem('cityId')
					if (String(cityId) === '521') {
						// 肇庆显示所有站点
						points = [...areaPoints, onStopPoint, offStopPoint, ...allStopsPoints].filter(p => !!p);
					} else {
						points = [...areaPoints, onStopPoint, offStopPoint].filter(p => !!p);
					}
				}
				console.log('|||--isMapFitViewModeA--points: ', points);
			}
			// 根据用户位置缩放地图
			if (context.$MapService.isMapFitViewModeB()) {
				let routeName = context.$route.name;
				if (routeName === 'Home') {
					context.$MapService.setMapFitViewModeA();
				}
				if (routeName === 'OrderRunning') {
					context.$MapService.setMapFitViewModeC();
				}
				if (routeName === 'Poi') {
					context.$MapService.setMapFitViewModeE();
				}
				let userPos = _getUserPos();
				console.log('|||--isMapFitViewModeB--userPos', userPos);
				let [lng, lat] = userPos || [];
				if (lng && lat) {
					let point = new BMapGL.Point(lng, lat);
					console.log('|||--isMapFitViewModeB--user-point: ', point);
					let map = _getMapInstance();
					if (map) {
						map.centerAndZoom(point, 13);
					}
				}
				return;
			}
			// 根据运行中的上、下车站和车辆缩放
			if (context.$MapService.isMapFitViewModeC()) {
				let runningOnStop = _getRunningOnStop();
				let runningOffStop = _getRunningOffStop();
				let busPos = _getBusPos();
				let {point: runningOnStopPoint} = runningOnStop || {};
				let {point: runningOffStopPoint} = runningOffStop || {};
				let {point: busPoint} = busPos || {};
				points = [runningOnStopPoint, runningOffStopPoint, busPoint].filter(p => !!p);
				margins[0] += 40;
				margins[1] += 20;
				margins[2] += 10;
				margins[3] += 180;
				console.log('|||--isMapFitViewModeC--points: ', points);
			}
			// 根据上车点缩放
			if (context.$MapService.isMapFitViewModeD()) {
				let {point: onStopPoint} = _getOnStop() || {};
				let map = _getMapInstance();
				if (map && onStopPoint) {
					let [lng, lat] = _getUserPos() || [];
					if (!lng || !lat) {
						map.centerAndZoom(onStopPoint, 14);
						return;
					} else {
						let farAway = isPointFarFromUser(onStopPoint, 10000);
						if (farAway) {
							map.centerAndZoom(onStopPoint, 14);
							return;
						}
						let userPoint = new BMapGL.Point(lng, lat);
						points = [onStopPoint, userPoint];
						margins[0] += 80;
						margins[1] += 40;
						margins[3] += 40;
					}
				}
			}
			// 根据下车点缩放
			if (context.$MapService.isMapFitViewModeE()) {
				let dragNearestOffStop = _getDragNearestOffStop();
				let {point} = dragNearestOffStop || {};
				let {point: offPoint} = _getOffStop() || {};
				if (point || offPoint) {
					let map = _getMapInstance();
					if (map) {
						map.centerAndZoom(point || offPoint, 16);
						return;
					}
				}
			}
		}
		if (!points) {
			return;
		}
		let opt = {
		};
		let bottom = _getMapMarginBottom();
		delay(() => {
			if (bottom > MAP_MARGIN_BOTTOM_BUFFER) {
				opt = {
					margins
				};
			}
			console.log('我是所有的点', points)
			map.setViewport(points, opt);
		}, MAP_SET_VIEWPORT_DELAY);
	}
	function setUserHeading(heading) {
		console.log('set user heading', heading);
	}
	function isPointFarFromUser(point, maxDistance) {
		let map = _getMapInstance();
		let [lng, lat] = _getUserPos() || [];
		if (!lng || !lat) {
			return false;
		}
		let userPos = new BMapGL.Point(lng, lat);
		let distance = map.getDistance(point, userPos);
		return distance > maxDistance;
	}
	return {
		// 1.地图属性
		// =====================
		/**
		 * 设置地图实例
		 * @param {Map} map
		 */
		setMapInstance(map) {
			dispatch(TYPES.MAP__SET_MAP_INSTANCE, map);
		},
		/**
		 * 设置地图障碍物占位边距
		 * @typedef {number} MapMarginTop - 上边距
		 * @typedef {number} MapMarginRight - 右边距
		 * @typedef {number} MapMarginBottom - 下边距
		 * @typedef {number} MapMarginLeft - 左边距
		 * @typedef {[MapMarginTop, MapMarginRight, MapMarginBottom, MapMarginLeft]} MapMargin - 障碍物占位边距
		 * @param {MapMargin} margins
		 */
		setMapMargins(margins) {
			dispatch(TYPES.MAP__SET_MAP_MARGINS, margins);
		},
		/**
		 * 设置地图障碍物下边距
		 * @param {MapMarginBottom} bottom
		 */
		setMapMarginBottom(bottom) {
			dispatch(TYPES.MAP__SET_MAP_MARGINS, [40+bottom, 40, bottom + 30, 40]);
			// dispatch(TYPES.MAP__SET_MAP_MARGIN_BOTTOM, bottom);
		},
		/**
		 * 根据el元素高度设置地图障碍物下边距
		 * @param {Element} el - 待监听元素
		 */
		observeMapObstruction: (el) => {
			dispatch(TYPES.MAP__SET_MAP_MARGIN_BOTTOM, 0);
			if (el) {
				delay(() => {
					let bottom = el.clientHeight || 0;
          console.log('bottom', bottom)
					dispatch(TYPES.MAP__SET_MAP_MARGINS, [40+bottom, 40, bottom + 30, 40]);
				}, 800);
			}
		},
		/**
		 * 设置地图模式
		 * @param mode
		 */
		setMapMode,
		/**
		 * 将地图模式设置为普通模式
		 */
		setMapModeNormal: () => {
			setMapMode(MAP_MODE_NORMAL);
		},
		/**
		 * 将地图模式设置为运行中模式
		 */
		setMapModeRunning: () => {
			setMapMode(MAP_MODE_RUNNING);
		},
		/**
		 * 判断是否是普通地图模式
		 * @return {boolean}
		 */
		isMapModeNormal: () => _getMapMode() === MAP_MODE_NORMAL,
		/**
		 * 判断是否是运行中地图模式
		 * @return {boolean}
		 */
		isMapModeRunning: () => _getMapMode() === MAP_MODE_RUNNING,
		/**
		 * 设置地图缩放模式
		 * @param mode
		 */
		setMapFitViewMode,
		/**
		 * 设置地图缩放模式为根据区域、上下车站缩放
		 */
		setMapFitViewModeA: () => {
			setMapFitViewMode(MAP_FIT_VIEW_MODE_A);
		},
		/**
		 * 设置地图缩放模式为根据用户缩放
		 */
		setMapFitViewModeB: () => {
			setMapFitViewMode(MAP_FIT_VIEW_MODE_B);
		},
		/**
		 * 设置地图缩放模式为根据运行中上、下车站和车辆缩放
		 */
		setMapFitViewModeC: () => {
			setMapFitViewMode(MAP_FIT_VIEW_MODE_C);
		},
		/**
		 * 设置地图缩放模式为根据上车站缩放
		 */
		setMapFitViewModeD: () => {
			setMapFitViewMode(MAP_FIT_VIEW_MODE_D);
		},
		/**
		 * 设置地图缩放模式为根据下车站缩放
		 */
		setMapFitViewModeE: () => {
			setMapFitViewMode(MAP_FIT_VIEW_MODE_E);
		},
		isMapFitViewModeA: () => {
			return _getMapFitViewMode() === MAP_FIT_VIEW_MODE_A;
		},
		isMapFitViewModeB: () => {
			return _getMapFitViewMode() === MAP_FIT_VIEW_MODE_B;
		},
		isMapFitViewModeC: () => {
			return _getMapFitViewMode() === MAP_FIT_VIEW_MODE_C;
		},
		isMapFitViewModeD: () => {
			return _getMapFitViewMode() === MAP_FIT_VIEW_MODE_D;
		},
		isMapFitViewModeE: () => {
			return _getMapFitViewMode() === MAP_FIT_VIEW_MODE_E;
		},
		// 2. 数据源
		// =====================
		/**
		 * 添加运营区域数据源
		 * @typedef {number} Lng - 经度
		 * @typedef {number} Lat - 纬度
		 * @typedef {[Lng, Lat]} DataAreaPoint - 运营区域节点
		 * @typedef {DataAreaPoint[]} DataArea - 运营区域数据源
		 * @param {DataArea} area - 运营区域
		 */
		addMapDataArea(area){
			dispatch(TYPES.MAP__ADD_MAP_DATA_AREA, area);
		},
		/**
		 * 设置运营区域数据源列表
		 * @param {DataArea[]} areas - 运营区域列表
		 */
		setMapDataAreas(areas) {
			dispatch(TYPES.MAP__SET_MAP_DATA_AREAS, areas);
		},
		/**
		 * 移除某一运营区域
		 * @param {number} index - 索引
		 */
		removeMapDataArea(index) {
			dispatch(TYPES.MAP__REMOVE_MAP_DATA_AREA, index);
		},
		/**
		 * 设置运营站点数据源列表
		 * @param stops
		 */
		setMapDataStops(stops) {
			dispatch(TYPES.MAP__SET_MAP_DATA_STOPS, stops);
		},
		/**
		 * 设置用户位置
		 * @param {[number, number]} pos - 坐标 [lng, lat]
		 */
		setMapDataUserPos(pos) {
			dispatch(TYPES.MAP__SET_MAP_USER_POS, pos);
		},
		/**
		 * 设置上车站对象
		 * @param {object} obj - 包含name, lng, lat, id
		 */
		setMapDataOnStop(obj) {
			dispatch(TYPES.MAP__SET_MAP_DATA_ON_STOP, obj);
		},
		/**
		 * 设置下车站对象
		 * @param obj - 包含name, lng, lat, id
		 */
		setMapDataOffStop(obj) {
			dispatch(TYPES.MAP__SET_MAP_DATA_OFF_STOP, obj);
		},
		/**
		 * 设置区域中心点
		 * @param {object} pos - 包含lng, lat
		 */
		setMapDataAreaCenterPos(pos) {
			dispatch(TYPES.MAP__SET_MAP_DATA_AREA_CENTER_POS, pos)
		},
		/**
		 * 设置车辆坐标
		 * @param {object} pos - 包含lng, lat
		 */
		setMapDataBusPos(pos) {
			dispatch(TYPES.MAP__SET_MAP_DATA_BUS_POS, pos);
		},
		/**
		 * 设置运行中的上车站位置对象
		 * @param {object} pos - 包含lng, lat
		 */
		setMapDataRunningOnStop(pos) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_ON_STOP, pos);
		},
		/**
		 * 设置运行中的下车站位置对象
		 * @param {object} pos - 包含lng, lat
		 */
		setMapDataRunningOffStop(pos) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_OFF_STOP, pos);
		},
		/**
		 * 设置运行中的脊线
		 * @param {Array} route - 脊线
		 */
		setMapDataRunningRoute(route) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_ROUTE, route)
		},
		/**
		 * 设置运行中的经停点
		 * @param {Array} posList
		 */
		setMapDataRunningNaviStop(posList) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP, posList)
		},
		// 3. 覆盖物
		// =====================
		/**
		 * 创建地图点
		 * @param lng
		 * @param lat
		 * @return {BMapGL.Point|null}
		 */
		createPoint(lng, lat) {
			if (!lng || !lat) return null;
			return new BMapGL.Point(lng, lat);
		},
		/**
		 * 设置运营区域多边形列表
		 * @param polygons
		 */
		setOverlayAreaPolygons(polygons = []) {
			dispatch(TYPES.MAP__SET_OVERLAY_AREA_POLYGONS, polygons);
		},
		/**
		 * 清空运营区域多边形列表（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayAreaPolygons: () => {
			let map = _getMapInstance();
			let polygons = _getOverlayAreaPolygons();
			if (map && polygons) {
				Array.from(polygons).forEach(polygon => {
					map.removeOverlay(polygon);
				});
				dispatch(TYPES.MAP__SET_OVERLAY_AREA_POLYGONS, []);
			}
		},
		/**
		 * 设置运营站点marker列表
		 * @param markers
		 */
		setOverlayStopMarkers(markers) {
			dispatch(TYPES.MAP__SET_OVERLAY_STOP_MARKERS, markers);
		},
		/**
		 * 清空运营站点覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayStopMarkers: () => {
			let map = _getMapInstance();
			let markers = _getOverlayStopMarkers();
			if (map && markers) {
				Array.from(markers).forEach(marker => {
					map.removeOverlay(marker);
				});
				dispatch(TYPES.MAP__SET_OVERLAY_STOP_MARKERS, []);
			}
		},
		/**
		 * 设置上车站marker
		 * @param marker
		 */
		setOverlayOnStopMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_ON_STOP_MARKER, marker);
		},
		/**
		 * 清空上车站覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayOnStopMarker() {
			let map = _getMapInstance();
			let marker = _getOverlayOnStopMarker();
			if (map && marker) {
				map.removeOverlay(marker);
				dispatch(TYPES.MAP__SET_OVERLAY_ON_STOP_MARKER, null);
			}
		},
		/**
		 * 设置上车站label
		 * @param label
		 */
		setOverlayOnStopLabel(label) {
			dispatch(TYPES.MAP__SET_OVERLAY_ON_STOP_LABEL, label);
		},
		/**
		 * 清空上车站label覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayOnStopLabel() {
			let map = _getMapInstance();
			let label = _getOverlayOnStopLabel();
			if (map && label) {
				map.removeOverlay(label);
				dispatch(TYPES.MAP__SET_OVERLAY_ON_STOP_LABEL, null);
			}
		},
		/**
		 * 设置下车站marker
		 * @param marker
		 */
		setOverlayOffStopMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_OFF_STOP_MARKER, marker);
		},
		/**
		 * 清空下车站覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayOffStopMarker() {
			let map = _getMapInstance();
			let marker = _getOverlayOffStopMarker();
			if (map && marker) {
				map.removeOverlay(marker);
				dispatch(TYPES.MAP__SET_OVERLAY_OFF_STOP_MARKER, null);
			}
		},
		/**
		 * 设置下车站label
		 * @param label
		 */
		setOverlayOffStopLabel(label) {
			dispatch(TYPES.MAP__SET_OVERLAY_OFF_STOP_LABEL, label);
		},
		/**
		 * 清空下车站label覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayOffStopLabel() {
			let map = _getMapInstance();
			let label = _getOverlayOffStopLabel();
			if (map && label) {
				map.removeOverlay(label);
				dispatch(TYPES.MAP__SET_OVERLAY_OFF_STOP_LABEL, null);
			}
		},
		/**
		 * 设置用户当前位置marker
		 * @param marker
		 */
		setOverlayUserPosMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_USER_POS_MARKER, marker);
		},
		/**
		 * 设置用户方向
		 * @param heading
		 */
		setOverlayUserPosMarkerHeading(heading) {
			let userMarker = _getOverlayUserPosMarker();
			if (heading && userMarker) {
				userMarker.setRotation(heading);
			}
		},
		/**
		 * 设置车辆marker
		 * @param marker
		 */
		setOverlayBusMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_BUS_MARKER, marker);
		},
		/**
		 * 清空车辆覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayBusMarker() {
			let map = _getMapInstance();
			let bus = _getOverlayBusMarker();
			if (map && bus) {
				map.removeOverlay(bus);
				dispatch(TYPES.MAP__SET_OVERLAY_BUS_MARKER, null);
			}
		},
		/**
		 * 设置运行中上车站marker
		 * @param marker
		 */
		setOverlayRunningOnStopMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER, marker);
		},
		/**
		 * 清空运行中上车站覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayRunningOnStopMarker() {
			let map = _getMapInstance();
			let marker = _getOverlayRunningOnStopMarker();
			if (map && marker) {
				map.removeOverlay(marker);
				dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER, null);
			}
		},
		/**
		 * 设置运行中上车站label
		 * @param label
		 */
		setOverlayRunningOnStopLabel(label) {
			dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL, label);
		},
		/**
		 * 清空运行中上车站覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayRunningOnStopLabel() {
			let map = _getMapInstance();
			let label = _getOverlayRunningOnStopLabel();
			if (map && label) {
				map.removeOverlay(label);
				dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL, null);
			}
		},
		/**
		 * 设置运行中下车站marker
		 * @param marker
		 */
		setOverlayRunningOffStopMarker(marker) {
			dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER, marker);
		},
		/**
		 * 清空运行中下车站覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayRunningOffStopMarker() {
			let map = _getMapInstance();
			let marker = _getOverlayRunningOffStopMarker();
			if (map && marker) {
				map.removeOverlay(marker);
				dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER, null);
			}
		},
		/**
		 * 设置运行中下车站label
		 * @param label
		 */
		setOverlayRunningOffStopLabel(label) {
			dispatch(TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL, label);
		},
		/**
		 * 清空运行中下车站label覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayRunningOffStopLabel() {
			let map = _getMapInstance();
			let label = _getOverlayRunningOffStopLabel();
			if (map && label) {
				map.removeOverlay(label);
				dispatch(MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL, null);
			}
		},
		/**
		 * 设置定位中动效label
		 * @param label
		 */
		setOverlayPosingLabel(label) {
			dispatch(TYPES.MAP__SET_OVERLAY_POSING_LABEL, label);
		},
		/**
		 * 清空定位中动效label覆盖物（包括地图显示和覆盖物对象存储）
		 */
		removeOverlayPosingLabel() {
			let map = _getMapInstance();
			let label = _getOverlayPosingLabel();
			if (map && label) {
				map.removeOverlay(label);
				dispatch(TYPES.MAP__SET_OVERLAY_POSING_LABEL, null);
			}
		},
		/**
		 * 设置运行中的脊线
		 * @param polyline
		 */
		setOverlayRunningPolyline(polyline) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_POLYLINE, polyline)
		},
		/**
		 * 清空运行中的脊线
		 */
		removeOverlayRunningPolyline() {
			let map = _getMapInstance();
			let polyline = context.$store.state.map.overlays.runningPolyline;
			if (map && polyline) {
        map.removeOverlay(polyline)
        dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_POLYLINE, null)
      }
		},
		/**
		 * 设置运行中的经停点
		 * @param markers
		 */
		setOverlayRunningNaviStopMarker(markers) {
			dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER, markers)
		},
		/**
		 * 清空运行中的经停点
		 */
		removeOverlayRunningNaviStopMarker() {
			let map = _getMapInstance();
			let markers = context.$store.state.map.overlays.runningNaviStopMarker;
			if (map && markers && markers.length) {
        map.removeOverlay(markers)
        dispatch(TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER, null)
      }
		},
		// 4. 状态
		// =====================
		/**
		 * 设置地图是否可见，该设置优先级高于路由中的mapVisible配置
		 * @param {boolean} visible
		 */
		setStateMapVisible(visible) {
			dispatch(TYPES.MAP__SET_STATE_MAP_VISIBLE, visible);
		},
		setStatePoiSearching,
		/**
		 * 设置拖拽地图是否可以选择上车站
		 * @param {boolean} draggable
		 */
		setStateOnStopDraggable(draggable) {
			dispatch(TYPES.MAP__SET_STATE_ON_STOP_DRAGGABLE, draggable);
		},
		/**
		 * 设置拖拽地图是否可以选择下车站
		 * @param {boolean} draggable
		 */
		setStateOffStopDraggable(draggable) {
			dispatch(TYPES.MAP__SET_STATE_OFF_STOP_DRAGGABLE, draggable);
		},
		/**
		 * 判断拖拽地图是否可以选择上车站
		 * @return {boolean}
		 */
		isOnStopDraggable() {
			return _getStateOnStopDraggable();
		},
		/**
		 * 判断拖拽地图是否可以选择下车站
		 * @return {boolean}
		 */
		isOffStopDraggable() {
			return _getStateOffStopDraggable();
		},
		/**
		 * 触发地图渲染递增值+1
		 */
		setMapRenderFlag() {
			dispatch(TYPES.MAP__SET_STATE_RENDER_FLAG);
		},
		/**
		 * 设置地图拖拽选取的最近下车站点
		 * @param stop
		 */
		setDragNearestOffStop(stop) {
			dispatch(TYPES.MAP__SET_STATE_DRAG_NEAREST_OFF_STOP, stop);
		},
		/**
		 * 设置上车站是否在拖拽中
		 * @param {Boolean} dragging
		 */
		setStateDraggingOn(dragging) {
			dispatch(TYPES.MAP__SET_STATE_DRAGGING_ON, dragging);
		},
		/**
		 * 设置下车站是否在拖拽中
		 * @param {Boolean} dragging
		 */
		setStateDraggingOff(dragging) {
			dispatch(TYPES.MAP__SET_STATE_DRAGGING_OFF, dragging);
		},
		// 5. 其他
		// =====================
		/**
		 * 绑定poi自动完成
		 * @param {Element} input - 输入框对象
		 * @param {Function} onSearchComplete - 搜索完成回调函数
		 */
		poiAutocomplete: ({input, onSearchComplete}) => {
			const map = _getMapInstance();
			if (!map) {
				return;
			}
			let local = new BMapGL.LocalSearch(map, {
				pageCapacity: 20,
				onSearchComplete: (ev) => {
					onSearchComplete(ev);
					setStatePoiSearching(false);
				}
			});
			function handler() {
				return throttle((ev) => {
					setStatePoiSearching(true);
					local.search(ev.target.value);
				});
			}
			input.addEventListener('input', handler(), false);
		},
		getLocation(opt = {}) {
			return new Promise((resolve) => {
				let geolocation = new BMapGL.Geolocation({
          maximumAge: 10, // 清除缓存
          ...(opt || {})
        })
				geolocation.getCurrentPosition(function(r) {
					if (this.getStatus() === BMAP_STATUS_SUCCESS) {
						const {lng, lat} = r.point || {};
						if (lng && lat) {
							dispatch(TYPES.MAP__SET_MAP_USER_POS, [lng, lat]);
							dispatch(TYPES.MAP__SET_MAP_USER_POS2, r) // 定位详细数据
							resolve([lng, lat]);
							return;
						}
						resolve(1);
					}
					resolve(2);
				}, function(e) {
					console.log('get location error', e);
					resolve(3);
				}, {enabledHighAccuracy: true});
			});
		},
		/**
		 * 获取用户当前位置
		 */
		getUserPos() {
			const [lng, lat] = _getUserPos() || [];
			return {
				lng,
				lat
			};
		},
		/**
		 * 地图定位到用户当前位置
		 */
		panToUserPos() {
			let map = _getMapInstance();
			let userPos = _getUserPos();
			if (map && userPos) {
				setFitView([new BMapGL.Point(...userPos)]);
				wait(60).then(() => {
					map.setZoom(15);
				});
			}
		},
		/**
		 * 地图定位到运营区域
		 */
		panToArea() {
			let map = _getMapInstance();
			let [area] = _getAreas() || [];
			if (map && area) {
				setFitView(area.map(point => {
					let [lng, lat] = point;
					return new BMapGL.Point(lng, lat);
				}));
			}
		},
		/**
		 * 根据点集调整地图视窗
		 * @param {Array} points
		 */
		setFitView,
		/**
		 * 根据城市名设置城市中心
		 * @param cityName
		 */
		setMapCity(cityName) {
			let map = _getMapInstance();
			if (map) {
				map.setCenter(cityName);
			}
		},
		/**
		 * 获取两点间距离
		 * @param pointFrom
		 * @param pointTo
		 * @return {number}
		 */
		getPointDistance(pointFrom, pointTo) {
			if (!pointFrom || !pointTo) {
				return 0;
			}
			return _getMapInstance().getDistance(pointFrom, pointTo);
		},
		/**
		 * 根据坐标获取最近站点
		 * @param {object} pos - lng, lat
		 * @return {null|unknown}
		 */
		findNearestStopByPos(pos) {
			let map = _getMapInstance();
			let {lng, lat} = pos || {};
			if (!lng || !lat) {
				return null;
			}
			let point = new BMapGL.Point(lng, lat);
			let lastDistance = Infinity;
			return Array.from(_getStops()).reduce((prev, stop) => {
				let {lng, lat} = stop || {};
				if (!lng || !lat) {
					return prev;
				}
				let stopPoint = new BMapGL.Point(lng, lat);
				const distance = map.getDistance(stopPoint, point);
				if (distance < lastDistance) {
					lastDistance = distance;
					return stop;
				} else {
					return prev;
				}
			}, null);
		},
		isPointOutOfRange(point, maxDistance = 3000) {
			let map = _getMapInstance();
			let bounds = _getOverlayAreaPolygons()[0].getBounds();
			let inRange = bounds.containsPoint(point);
			if (inRange) return false;
			let lastDistance = Infinity;
			let nearestPoint = Array.from(_getAreas()[0]).reduce((prev, stop) => {
				let [lng, lat] = stop || [];
				if (!lng || !lat) {
					return prev;
				}
				let stopPoint = new BMapGL.Point(lng, lat);
				const distance = map.getDistance(stopPoint, point);
				if (distance < lastDistance) {
					lastDistance = distance;
					return stop;
				} else {
					return prev;
				}
			}, null);
			if (nearestPoint) {
				nearestPoint = new BMapGL.Point(...nearestPoint);
				let distance = map.getDistance(nearestPoint, point);
				return distance > maxDistance;
			}
			return false;
		},
		setMapLoadCallback(cb) {
			const map = _getMapInstance();
			if (map) {
				map.addEventListener('tilesloaded', () => cb());
			}
		},
		setUserHeading,
		getCompassHeading() {
			return new Promise(resolve => {
				if (isIos()) {
					if (window.DeviceOrientationEvent) {
						let compassHeading = CompassHeading((_heading) => {
							resolve(_heading);
						});
						let {event, listener} = compassHeading;
						if (event && listener) {
							window.addEventListener(event, listener, true);
						}
					} else {
						resolve(undefined);
					}
				} else {
					let promise = FULLTILT.getDeviceOrientation({type: 'world'});
					promise.then((orientationControl) => {
						orientationControl.listen(() => {
							let screenAdjustedEvent = orientationControl.getScreenAdjustedEuler();
							let heading = Math.abs(360 - screenAdjustedEvent.alpha);
							resolve(heading);
						});
					}).catch(() => {
						resolve(undefined);
					});
				}
			});
		},
		isPointFarFromUser
	};
}

export function install(Vue, context) {
	Vue.prototype.$MapService = MapService(context);
}
